import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductTypeSelectorComponent } from './components/product-type-selector/product-type-selector.component';

@NgModule({
    declarations: [
        ProductTypeSelectorComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ProductTypeSelectorComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class TfProductTypeSelectorModule {
}
